<template>
  <div id="monochrome"></div>
</template>

<script>
import ApexCharts from 'apexcharts'
export default {
  name: "Monochrome",
  data() {
    return {
      options : {
        series: [42, 47, 52, 58, 65],
        chart: {
          width: 380,
          type: 'polarArea'
        },
        labels: ['Rose A', 'Rose B', 'Rose C', 'Rose D', 'Rose E'],
        fill: {
          opacity: 1
        },
        stroke: {
          width: 1,
          colors: undefined
        },
        yaxis: {
          show: false
        },
        legend: {
          position: 'bottom'
        },
        plotOptions: {
          polarArea: {
            rings: {
              strokeWidth: 0
            },
            spokes: {
              strokeWidth: 0
            },
          }
        },
        theme: {
          monochrome: {
            enabled: true,
            shadeTo: 'light',
            shadeIntensity: 0.6
          }
        }
      },
    }
  },
  mounted() {
    let chart = new ApexCharts(document.querySelector("#monochrome"), this.options);
    chart.render();
  }
}
</script>

<style scoped>

</style>